import { render, staticRenderFns } from "./DashboardAcessosAcessoFornecedorDia.vue?vue&type=template&id=0156e7be&scoped=true&"
import script from "./DashboardAcessosAcessoFornecedorDia.vue?vue&type=script&lang=js&"
export * from "./DashboardAcessosAcessoFornecedorDia.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAcessosAcessoFornecedorDia.vue?vue&type=style&index=0&id=0156e7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156e7be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
